// Smooth Scroll all hash links
document
  .querySelectorAll('a[href^="#"]:not([data-no-smooth-scroll])')
  .forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault(); // Prevent default jump behavior

      const targetId = this.getAttribute("href"); // Get the hash link's href
      const targetElement = document.querySelector(targetId); // Select the target element

      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: "smooth", // Enable smooth scrolling
        });
      }
    });
  });

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
    // const header_overlay = document.getElementById("mega-menu-overlay");
    //  header_overlay.style.display = 'none';
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

function setViewportCSSVariables() {
  const header = document.getElementById("shopify-section-header");
  const headerBottomPosition = parseInt(header.getBoundingClientRect().bottom);
  document.documentElement.style.setProperty(
    "--viewport-height",
    `${window.innerHeight}px`
  );
  document.documentElement.style.setProperty(
    "--header-bottom-position",
    headerBottomPosition > 0 ? `${headerBottomPosition}px` : "0px"
  );
}

setViewportCSSVariables();
window.addEventListener("resize", setViewportCSSVariables);

function convertCountryCodeToName(countryCode) {
  const regionNames = new Intl.DisplayNames(["en"], { type: "region" });
  return regionNames.of(countryCode);
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

Shopify.formatMoney = function (cents, format) {
  format = format || window.theme.moneyFormat || "${{amount}}";

  const amount = (cents / 100).toFixed(2);
  const amountNoDecimals = Math.round(cents / 100).toString();
  const amountWithComma = amount.replace(".", ",");
  const amountNoDecimalsWithComma = amountNoDecimals; // no decimals, so same

  const placeholders = {
    "{{amount}}": amount,
    "{{amount_no_decimals}}": amountNoDecimals,
    "{{amount_with_comma_separator}}": amountWithComma,
    "{{amount_no_decimals_with_comma_separator}}": amountNoDecimalsWithComma,
  };

  return format.replace(
    /\{\{[^}]+\}\}/g,
    (match) => placeholders[match] ?? match
  );
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(".menu-drawer__close-button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    if (
      !this.mainDetailsToggle.classList.contains("mobile-facets__disclosure")
    ) {
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
    }
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('[id^="ModalClose-"]').forEach((el) => {
      el.addEventListener("click", this.hide.bind(this, false));
    });
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    const id = this.id;
    const event = new CustomEvent("modalClosed", {
      detail: { id },
      bubbles: false,
    });
    this.dispatchEvent(event);
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = (this.button = this.querySelector("button"));

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class VariantModalOpener extends ModalOpener {
  constructor() {
    super();
  }

  //  Used to show/hide the popup trigger
  get metafieldKey() {
    return this.getAttribute("metafield-key") || null;
  }

  connectedCallback() {
    this.onVariantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      this.onVariantChange.bind(this)
    );
  }

  onVariantChange(event) {
    const { currentVariant } = event.data;

    if (currentVariant && this.metafieldKey) {
      const showTrigger =
        currentVariant.metafields.find((mf) =>
          mf.hasOwnProperty(this.metafieldKey)
        ) ?? false;

      this.showTrigger(showTrigger);
    }
  }

  showTrigger(showTrigger) {
    showTrigger
      ? this.button.removeAttribute("hidden")
      : this.button.setAttribute("hidden", "");
  }
}

customElements.define("variant-modal-opener", VariantModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    if (poster.classList.contains("no_poster")) {
      this.checkIfVideoInView = this.checkIfVideoInView.bind(this);
      document.addEventListener("scroll", this.checkIfVideoInView);
    } else {
      poster.addEventListener("click", this.loadContent.bind(this));
    }
  }

  checkIfVideoInView() {
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    const posterBoundingClientRect = poster.getBoundingClientRect();
    const top = posterBoundingClientRect.top - 50;
    const bottom = posterBoundingClientRect.bottom + 50;
    const posterInView = top <= window.innerHeight && bottom >= 0;
    if (posterInView) {
      this.loadContent();
      this.removeVideoListener();
    }
  }

  removeVideoListener(el) {
    document.removeEventListener("scroll", this.checkIfVideoInView);
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();

      const ad = this.closest(".card-wrapper__ad");
      if (!ad) return;
      ad.classList.add("video-loaded");
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class ProductMedia extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      mediaSlider: this.querySelector(".product__media-slider"),
      imageContainer: this.querySelectorAll(".product-image-container"),
      images: this.querySelectorAll(".product-image-container img"),
      videoContainer: this.querySelector(".product-video-container"),
      variantBadge: this.querySelectorAll(".product__variant-badge"),
    };
    this.$mediaSlider = null;
    this.hasVideo = this.querySelector(".product-video-container")
      ? true
      : false;
    this.lightbox = null;
    this.currentColor = null;
    this.mediaQuery = window.matchMedia("(max-width: 767px)");
    this.isMobile = this.mediaQuery.matches;
    this.sectionId = this.dataset.section;
    this.enableDesktopSlider = this.dataset.enableDesktopSlider === "true";
    this.desktopSlidesToShow = parseInt(this.dataset.desktopSlidesToShow);
  }

  connectedCallback() {
    this.onVariantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      this.handleVariantChange.bind(this)
    );

    if (this.isMobile || this.enableDesktopSlider) {
      this.initMediaSlider(this.currentColor);
    }

    // Listen for device resizing
    this.mediaQuery.addEventListener(
      "change",
      this.onBreakpointChange.bind(this)
    );

    this.elements.videoContainer?.addEventListener(
      "click",
      this.toggleVideoPlay.bind(this)
    );

    this.initLightbox();
  }

  handleVariantChange({ data }) {
    // Do not update media if event is not triggered by correct section
    if (data.sectionId !== this.sectionId) return;
    this.currentColor = data.currentColor;
    this.currentVariant = data.currentVariant;

    this.updateMedia();
  }

  onBreakpointChange(e) {
    // Allow slider to keep running on desktop
    if (this.enableDesktopSlider) return;

    // Destroy slider on desktop
    if (!e.matches && this.$mediaSlider !== null) {
      this.destroyMediaSlider();
      this.updateImagesVisibility(this.currentColor);
    } else if (e.matches && this.$mediaSlider === null) {
      this.initMediaSlider(this.currentColor);
    }
  }

  /**
   * Init the product media slider
   * @param {String} color - Hyphenated color option
   */
  initMediaSlider(color) {
    if (this.$mediaSlider !== null) return;
    if (this.elements.imageContainer.length <= 1) return;

    const options = {
      slidesToShow: 1.05,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      infinite: false,
      mobileFirst: true,
      ...(this.enableDesktopSlider && {
        responsive: [
          {
            breakpoint: 990,
            settings: {
              slidesToShow: this.desktopSlidesToShow,
              slidesToScroll: this.desktopSlidesToShow,
              nextArrow: $(".next-arrow", this),
              prevArrow: $(".prev-arrow", this),
              arrows: true,
            },
          },
        ],
      }),
    };

    this.$mediaSlider = $(this.elements.mediaSlider).slick(options);

    // Filter out color
    if (color) {
      this.$mediaSlider.slick(
        "slickFilter",
        `[option="${color}"], .product-video-container`
      );
    }

    if (this.hasVideo) {
      this.updateSliderDots();
    }
  }

  /**
   * Update the slider with the current color
   *
   * @param {String} color - Hyphenated color option
   * @returns
   */
  updateMediaSlider(color) {
    if (this.$mediaSlider === null) return;

    this.$mediaSlider
      .slick("slickUnfilter")
      .slick("slickFilter", `[option="${color}"], .product-video-container`)
      .slick("slickGoTo", 0);

    if (this.hasVideo) {
      this.updateSliderDots();
    }
  }

  destroyMediaSlider() {
    if (this.$mediaSlider === null) return;
    this.$mediaSlider.slick("slickUnfilter");
    this.$mediaSlider.slick("unslick");
    this.$mediaSlider = null;
  }

  updateMedia() {
    this.updateImagesVisibility(this.currentColor);
    this.updateMediaSlider(this.currentColor);
    this.updateVariantBadge(this.currentVariant);
  }

  updateSliderDots() {
    const slickDots =
      this.elements.mediaSlider.querySelectorAll(".slick-dots li");
    const lastDot = slickDots[slickDots.length - 1];
    lastDot.classList.add("video-dot");
  }

  initLightbox() {
    this.lightbox = GLightbox();
  }

  toggleVideoPlay(event) {
    const el = event.currentTarget;
    const video = el.querySelector("video");
    const iconPlay = el.querySelector(".icon-play");
    const iconStop = el.querySelector(".icon-stop");

    if (video.paused) {
      video.play();
      iconPlay.style.display = "none";
      iconStop.style.display = "block";
    } else {
      video.pause();
      iconPlay.style.display = "block";
      iconStop.style.display = "none";
    }
  }

  updateVariantBadge(currentVariant) {
    if (!currentVariant) return;
    this.elements.variantBadge.forEach((el) => {
      if (parseInt(el.dataset.variantId) === currentVariant.id) {
        el.classList.remove("d-none");
      } else {
        el.classList.add("d-none");
      }
    });
  }

  updateImagesVisibility(color) {
    if (this.enableDesktopSlider) return;

    if (color) {
      this.elements.images.forEach((image) => {
        const imageAlt = handleize(image.alt);
        if (imageAlt === this.currentColor) {
          image.parentElement.style.display = "block";
        } else {
          image.parentElement.style.display = "none";
        }
      });
    }
  }
}

customElements.define("product-media", ProductMedia);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.updateOptions();
    this.updateSoldOut();
    this.addEventListener("change", this.onVariantChange);
    this.elements = {
      productMedia: this.closest(".product").querySelector("product-media"),
      colorLabels: this.querySelectorAll(
        `.product-form__input[data-option-name="${handleize(window.theme.locale.products.variants.color_option)}"] label`
      ),
      colorInputs: this.querySelectorAll(
        `.product-form__input[data-option-name="${handleize(window.theme.locale.products.variants.color_option)}"] input`
      ),
    };
  }

  connectedCallback() {
    this.updateMasterId();
    // Send payload data on mounted
    this.publishVariantChange();

    // On page load
    if (this.currentVariant) {
      this.hideNotifyBtn(this.currentVariant);
    }
  }

  publishVariantChange() {
    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        currentVariant: this.currentVariant,
        currentColor: this.currentColor,
        sectionId: this.dataset.section,
      },
    });
  }

  onVariantChange(event) {
    console.log("👛 VARIANT CHANGE");
    this.updateOptions();
    this.updateMasterId();
    this.removeErrorMessage();
    this.updateSoldOut();
    this.updateFieldsetText();
    this.publishVariantChange();

    if (!this.currentVariant) {
      this.setUnavailable();
      this.hideNotifyBtn();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateInventoryTracker();
      this.hideNotifyBtn(this.currentVariant);
    }
  }

  updateInventoryTracker() {
    const section = this.closest(".product");
    const inventoryAlert = section.querySelectorAll(
      "[data-js-variant-inventory]"
    );

    if (!inventoryAlert) {
      return;
    }

    inventoryAlert.forEach((el) => {
      const id = parseInt(el.dataset.variantId);
      const lowInventory = /true/.test(el.dataset.lowInventory);
      const available = /true/.test(el.dataset.available);

      if (id === this.currentVariant.id && lowInventory && available) {
        el.style.display = "flex";
      } else {
        el.style.display = "none";
      }
    });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateSoldOut() {
    const optionElements = Array.from(this.querySelectorAll("fieldset"));
    if (!optionElements) return;

    this.optionValues = optionElements.map((el) => {
      return el.tagName === "SELECT"
        ? el.value
        : Array.from(el.querySelectorAll("input")).find(
            (radio) => radio.checked
          ).value;
    });

    const selectedColor = this.options[0]; // Assuming color is the first option
    const selectedSize = this.options[1]; // Assuming size is the second option

    // Reset all inputs - remove disabled and soldout classes
    optionElements.forEach((fieldset) => {
      const inputs = fieldset.querySelectorAll("input");
      inputs.forEach((input) => {
        input.classList.remove("disabled", "soldout");
      });
    });

    // Handle COLOR filtering based on selected SIZE
    if (selectedSize && optionElements[0]) {
      const colorFieldset = optionElements[0];
      const colorInputs = colorFieldset.querySelectorAll("input");

      colorInputs.forEach((colorInput) => {
        const colorValue = colorInput.value;

        // Check if this color has the selected size available
        const variantWithColorAndSize = this.getVariantData().find(
          (variant) =>
            variant.option1 === colorValue &&
            variant.option2 === selectedSize &&
            variant.available
        );

        if (!variantWithColorAndSize) {
          colorInput.classList.add("disabled", "soldout");
          console.log(
            `❌ Color ${colorValue} doesn't have size ${selectedSize} available`
          );
        }
      });
    }

    // Handle SIZE filtering based on selected COLOR
    if (selectedColor && optionElements[1]) {
      const sizeFieldset = optionElements[1];
      const sizeInputs = sizeFieldset.querySelectorAll("input");

      sizeInputs.forEach((sizeInput) => {
        const sizeValue = sizeInput.value;

        // Find the variant for this color and size combination
        const variantWithColorAndSize = this.getVariantData().find(
          (variant) =>
            variant.option1 === selectedColor && variant.option2 === sizeValue
        );

        if (!variantWithColorAndSize || !variantWithColorAndSize.available) {
          // Use 'disabled' for both non-existent and sold-out variants
          sizeInput.classList.add("disabled", "soldout");
          if (!variantWithColorAndSize) {
            console.log(
              `❌ Size ${sizeValue} doesn't exist in color ${selectedColor}`
            );
          } else {
            console.log(
              `❌ Size ${sizeValue} is sold out in color ${selectedColor}`
            );
          }
        } else {
          console.log(
            `✅ Size ${sizeValue} is available in color ${selectedColor}`
          );
        }
      });
    }
  }

  updateFieldsetText() {
    const currOptions = this.options;
    const fieldsets = this.querySelectorAll("fieldset");
    fieldsets.forEach((fieldset, index) => {
      const optionValue = fieldset.querySelector(
        "legend [data-selected-option]"
      );
      optionValue.innerText = currOptions[index];
    });
    document
      .querySelectorAll(".product-options-mobile .product-option-value")
      .forEach((val, index) => {
        val.innerText = currOptions[index];
      });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        let html = new DOMParser().parseFromString(responseText, "text/html");
        let destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        let source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        let price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    this.toggleAddButton(true, "", true);
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-custom-product-json]").textContent);
    return this.variantData;
  }

  hideNotifyBtn(currentVariant) {
    const parentNode = this.closest(".product");

    // Hide the BIS button when no variant exists
    if (!currentVariant) {
      parentNode.classList.add("hide-bis-btn");
      return;
    }

    // Remove hidden class on all variant changes first
    parentNode.classList.remove("hide-bis-btn");

    if (currentVariant.metafields.length > 0) {
      const foundMetafield = currentVariant.metafields.find((m) =>
        m.hasOwnProperty("hide_notify_button")
      );

      if (foundMetafield && foundMetafield["hide_notify_button"]) {
        parentNode.classList.add("hide-bis-btn");
      }
    }
  }

  get selectedOptionValues() {
    return Array.from(
      this.querySelectorAll("select option[selected], fieldset input:checked")
    ).map(({ value }) => value);
  }

  get currentColor() {
    if (!this.currentVariant) return null;

    const colorIndex = this.currentVariant.product.options.findIndex(
      (option) => {
        const optionName = option.toLowerCase();
        return optionName.includes(
          window.theme.locale.products.variants.color_option.toLowerCase()
        );
      }
    );

    if (colorIndex === -1) return null;

    return this.selectedOptionValues.length
      ? handleize(this.selectedOptionValues[colorIndex])
      : null;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class VariantForm extends HTMLElement {
  constructor() {
    super();
    this.items = [];
    this.elements = {
      quantityInputs: this.querySelectorAll('input[type="number"]'),
      images: this.querySelectorAll("img"),
    };

    this.addEventListener("change", this.onVariantChange);
  }

  connectedCallback() {
    const selectedRadio = this.querySelector('input[type="radio"]:checked');
    this.updateSelectedVariant(selectedRadio.value);

    // Send payload data on mounted
    this.publishVariantChange();

    // Bind event handlers
    this.elements.quantityInputs.forEach((el) => {
      el.addEventListener("change", this.onQtyChange.bind(this));
    });
    this.elements.images.forEach((el) => {
      el.addEventListener("click", this.onImageClick.bind(this));
    });
  }

  publishVariantChange() {
    publish(PUB_SUB_EVENTS.variantChange, {
      data: {
        currentVariant: this.currentVariant,
        currentColor: this.currentColor,
        sectionId: this.dataset.section,
      },
    });
  }

  onVariantChange(event) {
    const id = event.detail?.id || event.target.value;
    this.updateSelectedVariant(id);
    this.updateURL();
    this.publishVariantChange();
  }

  onQtyChange(event) {
    event.stopPropagation();
    const currentTarget = event.currentTarget;
    const quantity = this.validateQty(currentTarget, currentTarget.value);
    const id = parseInt(currentTarget.dataset.variantId);
    const item = { id, quantity };
    const itemInArrIndex = this.items.findIndex((item) => item.id === id);

    if (itemInArrIndex === -1) {
      this.items.push(item);
    } else {
      this.items[itemInArrIndex] = item;
    }
  }

  validateQty(el, quantity) {
    const max = parseInt(el.max);
    const qty = parseInt(quantity);

    if (qty > max) {
      el.value = parseInt(max);
      return parseInt(max);
    } else {
      return qty;
    }
  }

  resetQuantities() {
    this.elements.quantityInputs.forEach((el) => (el.value = 0));
    this.items = [];
  }

  onImageClick(event) {
    const el = event.currentTarget;
    const radio = el.nextElementSibling;
    const evt = new CustomEvent("change", {
      bubbles: true,
      cancelable: true,
      detail: {
        id: radio.value,
      },
    });
    radio.checked = true;
    radio.dispatchEvent(evt);
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector("[data-custom-product-json]").textContent);
    return this.variantData;
  }

  updateSelectedVariant(id) {
    this.currentVariant = this.getVariantData().find((variant) => {
      return variant.id === parseInt(id);
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  get currentColor() {
    if (!this.currentVariant) return null;

    const colorIndex = this.currentVariant.product.options.findIndex(
      (option) => {
        return (
          option.toLowerCase() ===
          window.theme.locale.products.variants.color_option.toLowerCase()
        );
      }
    );

    if (colorIndex === -1) return null;

    return handleize(this.currentVariant.options[colorIndex]);
  }
}

customElements.define("variant-form", VariantForm);

String.prototype.imgURL = function (size) {
  return this.replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
    return "_" + size + match;
  });
};

// Lazy load background images
const lazyBackgrounds = document.querySelectorAll("[data-lazy-load-bg]");
const lazyVideos = document.querySelectorAll("video.lazyload");

function initLazyLoadBackgrounds() {
  let lazyBackgroundObserver = new IntersectionObserver(function (
    entries,
    observer
  ) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("lazy-loaded");
        lazyBackgroundObserver.unobserve(entry.target);
      }
    });
  });

  lazyBackgrounds.forEach(function (lazyBackground) {
    lazyBackgroundObserver.observe(lazyBackground);
  });
}

function initLazyVideos() {
  const lazyVideoObserver = new IntersectionObserver(function (
    entries,
    observer
  ) {
    entries.forEach(function (video) {
      if (video.isIntersecting) {
        for (var source in video.target.children) {
          var videoSource = video.target.children[source];
          if (
            typeof videoSource.tagName === "string" &&
            videoSource.tagName === "SOURCE"
          ) {
            videoSource.src = videoSource.dataset.src;
          }
        }

        video.target.load();
        video.target.classList.remove("lazyload");
        lazyVideoObserver.unobserve(video.target);
      }
    });
  });

  lazyVideos.forEach(function (lazyVideo) {
    lazyVideoObserver.observe(lazyVideo);
  });
}

initLazyLoadBackgrounds();
initLazyVideos();

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.variantSwatches = this.querySelectorAll(".product-card__swatch");
    this.primaryImg = this.querySelector(".product-card__featured-image");
    this.secondaryImg = this.querySelector(".product-card__secondary-image");
    this.primaryLink = this.querySelector(".product-card__featured-image-link");
    this.secondaryLink = this.querySelector(
      ".product-card__secondary-image-link"
    );
  }

  connectedCallback() {
    this.variantSwatches.forEach((el) => {
      el.addEventListener("mouseenter", this.onSwatchEnter.bind(this));
      el.addEventListener("focusin", this.onSwatchEnter.bind(this));
    });
  }

  onSwatchEnter(event) {
    const el = event.currentTarget;
    const variantUrl = el.dataset.variantUrl;
    const primaryImageSrc = el.dataset.primaryImageSrc;
    const primaryImageSrcset = el.dataset.primaryImageSrcset;
    const secondaryImageSrc = el.dataset.secondaryImageSrc;
    const secondaryImageSrcset = el.dataset.secondaryImageSrcset;

    this.primaryLink.setAttribute("href", variantUrl);
    this.primaryImg.setAttribute("src", primaryImageSrc);
    this.primaryImg.setAttribute("srcset", primaryImageSrcset);

    if (this.secondaryImg && this.secondaryLink) {
      this.secondaryLink.setAttribute("href", variantUrl);
      this.secondaryImg.setAttribute("src", secondaryImageSrc);
      this.secondaryImg.setAttribute("srcset", secondaryImageSrcset);
    }
  }
}

customElements.define("product-card", ProductCard);

/* eslint-disable */
// t = current time
// b = start value
// c = change in value
// d = duration
Math.easeInOutQuad = function (t, b, c, d) {
  t /= d / 2;
  if (t < 1) return (c / 2) * t * t + b;
  t--;
  return (-c / 2) * (t * (t - 2) - 1) + b;
};
/* eslint-enable */

/**
 * Shopify-like handleize
 * - lowercase
 * - replace & with "and"
 * - normalize and remove diacritics (if supported)
 * - replace runs of non-alphanumerics with single hyphen
 * - trim hyphens
 *
 * @param {string|null|undefined} input
 * @returns {string}
 */
function handleize(input) {
  // safe string
  let s = String(input ?? "");

  // trim + lowercase early
  s = s.trim().toLowerCase();

  // replace ampersands with the word 'and'
  s = s.replace(/&+/g, " and ");

  // normalize & remove diacritics if supported
  // use \p{M} (Mark) which is widely supported; \p{Diacritic} also works in many engines
  if (s.normalize) {
    try {
      s = s.normalize("NFD").replace(/\p{M}/gu, "");
    } catch (e) {
      // fallback if Unicode property escapes are not supported
      s = s.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
  }

  // Replace any sequence of non ASCII letters/numbers with a hyphen.
  // Note: this keeps any remaining non-latin letters as-is (they'll become hyphens below).
  s = s.replace(/[^a-z0-9]+/g, "-");

  // collapse multiple hyphens and trim
  s = s.replace(/-+/g, "-").replace(/^-+|-+$/g, "");

  return s;
}

class SizeGuide extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      table: this.querySelector("table"),
      checkbox: this.querySelector(".size-guide__switch-input"),
      cellsIN: this.querySelectorAll('span[data-unit="in"]'),
      cellsCM: this.querySelectorAll('span[data-unit="cm"]'),
      sizeGuideBtn: document.querySelectorAll('a[href="#size-guide"]'),
      overlay: document.getElementById("size-guide-overlay"),
      popUp: document.querySelector(".size-guide-main"),
      popupCloseBtn: document.querySelector(".size-guide__close-btn"),
    };
  }

  connectedCallback() {
    this.elements.checkbox.addEventListener(
      "change",
      this.onCheckboxChange.bind(this)
    );

    this.elements.sizeGuideBtn.forEach((el) => {
      el.addEventListener("click", this.showSizeGuide.bind(this));
    });

    this.elements.overlay.addEventListener(
      "click",
      this.hideSizeGuide.bind(this)
    );
    this.elements.popupCloseBtn.addEventListener(
      "click",
      this.hideSizeGuide.bind(this)
    );
  }

  onCheckboxChange(event) {
    const el = event.currentTarget;

    if (el.checked) {
      this.elements.table.setAttribute("data-unit", "cm");
      this.hideUnitCell(this.elements.cellsIN, true);
      this.hideUnitCell(this.elements.cellsCM, false);
    } else {
      this.elements.table.setAttribute("data-unit", "in");
      this.hideUnitCell(this.elements.cellsIN, false);
      this.hideUnitCell(this.elements.cellsCM, true);
    }
  }

  hideUnitCell(elements, hide) {
    elements.forEach((el) => {
      if (hide) {
        el.classList.add("d-none");
        el.classList.remove("d-block");
      } else {
        el.classList.remove("d-none");
        el.classList.add("d-block");
      }
    });
  }

  showSizeGuide(event) {
    event.preventDefault();
    this.elements.overlay.classList.add("is-open");
    this.elements.popUp.classList.add("is-open");
    document.querySelector("body").style.overflow = "hidden";
  }

  hideSizeGuide() {
    this.elements.overlay.classList.remove("is-open");
    this.elements.popUp.classList.remove("is-open");
    document.querySelector("body").style.overflow = "";
  }
}

customElements.define("size-guide", SizeGuide);

class ProductFinalSale extends HTMLElement {
  constructor() {
    super();
    this.country = convertCountryCodeToName(Shopify.country);
  }

  connectedCallback() {
    this.onVariantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      this.handleVariantChange.bind(this)
    );
  }

  handleVariantChange({ data }) {
    const { currentVariant } = data;
    const foundMetafield =
      currentVariant.metafields?.find((m) => m.hasOwnProperty("final_sale")) ||
      null;
    const foundCountry = foundMetafield
      ? foundMetafield["final_sale"].find((c) => c === this.country)
      : null;

    foundMetafield && foundCountry
      ? (this.style.display = "block")
      : (this.style.display = "none");
  }
}
customElements.define("product-final-sale", ProductFinalSale);
